<template>
  <v-card align="center" justify="center" light outlined>
    <v-card-title  style="background-color: #d2d7e1">
      <h2>{{ $t('title') }}</h2>
      <v-spacer/>
      <v-icon class="icon" @click="close">fa-times</v-icon>
    </v-card-title>
    <v-card-text class="pa-5">
      <v-color-picker v-model="color" mode="hexa" hide-mode-switch flat/>
      <v-divider class="my-2"/>
      <div class="pa-3" :style="`background-color: ${color}; color: #FFFFFF;`" v-html="$t('contrastMessage')" readonly rounded/>
      <v-divider class="my-2"/>
      <v-btn class="ma-3" @click="saveColor">{{ $t('btnSave') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    initialColor: String,
  },
  data() {
    return {
      color: '',
    };
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.color = `#${this.initialColor}`;
    },
    saveColor() {
      this.$emit('saveColor', this.color);
    },
    close() {
      this.$emit('closeWindow');
    },
  },
}
</script>

<i18n>
{
  "en": {
    "title": "Choose a color",
    "contrastMessage": "If you read without problems,<br>it's OK in contrast",
    "btnSave": "Select color"
  },
  "es": {
    "title": "Escoje un color",
    "contrastMessage": "Si puedes leer sin problema,<br>esta bien el contraste",
    "btnSave": "Seleccionar color"
  }
}
</i18n>

<style scoped>

</style>
